import React from "react"
import {ReplacementHistory as RH} from "../../../dtos/orderResponse"
import {Event} from "../../../dtos/eventResponse"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Divider,
	Grid,
	Typography,
} from "@mui/material"

interface ReplacementHistoryProps {
	replacementHistory: RH[]
	lastReplacementFailure: Event[] | undefined
}

const renderLabelValue = ({
	label,
	value,
	labelProps,
}: {
	label: any
	value: any
	labelProps?: any
}) => {
	return (
		<Grid container>
			<Grid item xs={7}>
				<Typography variant="subtitle1" style={{...labelProps}}>
					{label}
				</Typography>
			</Grid>
			<Grid item xs={5}>
				<Typography variant="caption" style={{color: "gray", fontSize: "11px"}}>
					{value}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default function ReplacementHistory(props: ReplacementHistoryProps) {
	return (
		<div>
			<Accordion style={{margin: 5}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography style={{fontWeight: "bold", display: "inline-block"}}>
						Replacement History
					</Typography>
				</AccordionSummary>
				<AccordionDetails style={{display: "inline-block"}}>
					{renderLabelValue({
						label: "Successful Replacement requests",
						value: props.replacementHistory.length,
						labelProps: {fontWeight: "bold"},
					})}
					{props.replacementHistory.length >= 1 && (
						<div>
							<Typography style={{fontWeight: "bold", display: "inline-block"}}>
								Last successful replacement
							</Typography>
							{renderLabelValue({
								label: "Date",
								value: `${new Date(props.replacementHistory[0].replacedOn)}`,
							})}
							{renderLabelValue({
								label: "Quantity",
								value: props.replacementHistory[0].quantity,
							})}
							{renderLabelValue({
								label: "Reason",
								value: props.replacementHistory[0].reason,
							})}
						</div>
					)}
					<Divider variant="middle" style={{margin: 5}} />
					{renderLabelValue({
						label: "Failed Replacement requests",
						value: props.lastReplacementFailure ? props.lastReplacementFailure.length : 0,
						labelProps: {fontWeight: "bold"},
					})}
					{props.lastReplacementFailure &&
						props.lastReplacementFailure[0] &&
						props.lastReplacementFailure[0].itemInfo &&
						props.lastReplacementFailure[0].itemInfo[0] &&
						props.lastReplacementFailure[0].itemInfo[0].itemProperties && (
							<div>
								<Typography style={{fontWeight: "bold", display: "inline-block"}}>
									Last failed replacement
								</Typography>
								{renderLabelValue({
									label: "Date",
									value: `${new Date(props.lastReplacementFailure[0].dateTime)}`,
								})}
								{renderLabelValue({
									label: "Quantity",
									value: props.lastReplacementFailure[0].itemInfo[0].quantity,
								})}
								{renderLabelValue({
									label: "Reason",
									value:
										props.lastReplacementFailure[0].itemInfo[0].itemProperties.replacementReason,
								})}
								{renderLabelValue({
									label: "Failure reason",
									value:
										props.lastReplacementFailure[0].eventProperties &&
										props.lastReplacementFailure[0].eventProperties.replacementRejectionReason
											? props.lastReplacementFailure[0].eventProperties.replacementRejectionReason
											: "",
								})}
							</div>
						)}
				</AccordionDetails>
			</Accordion>
		</div>
	)
}
